import {FC, useContext} from 'react';
import DropdownContext from 'components/Form/Base/BaseDropdown/context';
import Spinner from 'components/Loaders/Spinner';
import {t} from 'ttag';
import {Option} from 'types';
import DrawerOption from '../DrawerOption';

const DrawerContent: FC = () => {
    const {
        isLoading,
        isMultiChoices,
        isOptionSelected,
        onClickOption,
        options,
        searchQueryDebounced,
    } = useContext(DropdownContext);

    if (isLoading) {
        return (
            <div className="pointer-events-auto px-3 py-1" role="status">
                <span className="flex justify-center">
                    <Spinner />
                </span>
            </div>
        );
    }

    if (options.length === 0) {
        return (
            <div className="pointer-events-auto px-3 py-1" role="status">
                {searchQueryDebounced === '' ? null : t`No results found`}
            </div>
        );
    }

    return (
        <div className="pointer-events-auto max-h-60 overflow-y-auto">
            {options.map((option: Option) => (
                <DrawerOption
                    key={option.value}
                    aria-label={`${option.label}`}
                    disabled={option.disabled}
                    isCheckable={isMultiChoices || false}
                    label={option.label}
                    onClick={() => onClickOption(option.value)}
                    selected={isOptionSelected(option)}
                    status={option.status}
                    value={option.value}
                />
            ))}
        </div>
    );
};

export default DrawerContent;
